<template><div style="display: none"></div></template>
<script>
import transaction from '@/mixins/transaction'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'NotificationMessage',
  created () {
    if (!this.notificationShown) {
      this.customerNotifications().then((response) => {
        this.showNotification(response.notifications)
      })
    }
  },
  computed: {
    ...mapGetters('notification', [
      'notificationShown'
    ])
  },
  methods: {
    ...mapActions('notification', [
      'customerNotifications'
    ]),
    ...mapMutations('notification', [
      'showNotification'
    ]),
    ...mapMutations(['addMessage']),
    showNotification (notifications) {
      if (notifications) {
        notifications.forEach(notification => {
          if (notification.webText !== null) {
            this.addMessage({
              type: 'warning',
              message: notification.webText,
              ...this.showModal(notification)
            })
          }
        })
      }
    },
    showModal (notification) {
      if (notification.webDetailsText !== null && notification.webDetailsText !== '') {
        return {
          messageLink: 'Mehr Infos',
          messageModalContent: notification.webDetailsText
        }
      } else {
        return {}
      }
    }
  },
  mixins: [
    transaction('customerNotifications')
  ]
}
</script>
